interface UploadIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function UploadIcon({ color = 'currentColor', ...svgProps }: UploadIconProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14 11.5816V25.5816M17.7059 14.6498L13.9936 10.9375L10.2812 14.6498M7.4375 18.375H19.25C22.1495 18.375 24.5 15.9533 24.5 12.9659C24.5 9.97854 22.1495 7.55681 19.25 7.55681C18.7539 7.55681 18.2738 7.62772 17.8188 7.76023C17.3076 5.32474 15.2044 3.5 12.6875 3.5C9.78801 3.5 7.4375 5.92173 7.4375 8.90909C7.4375 9.37603 7.49493 9.82915 7.6029 10.2614H7.4375C5.26288 10.2614 3.5 12.0777 3.5 14.3182C3.5 16.5587 5.26288 18.375 7.4375 18.375Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
